import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import crifImage from "./crifImage.png";
import equifaxLogo from "./equifaxLogo.png";
import alert from "./alert.png";
import faqIcon from "./faqIcon.png";
import arrowRight from "./arrowRight.png";
import { Spin } from "antd";
import { onecodeAPI } from "../AppConfig";
import { useTranslation } from "react-i18next";
import DynamicTextFormatter from "./DynamicTextFormatter";
import moment from "moment";
import "./Recommender.css";
import CreditScoreCircularBar from "./CreditScoreCircularBar";
import CreditScoreInfoModal from "./CreditScoreInfoModal";

export default function CreditScore({ hash, customerDetails, setCustomer }) {
  const navigate = useNavigate();
  const [valueEnd, setValueEnd] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [noCreditReport, setNoCreditReport] = useState(false);
  const [creditScoreData, setCreditScoreData] = useState({
    personalLoans: 0,
    creditCards: 0,
    activeAccounts: 0,
    bureauName: "",
  });
  const { t } = useTranslation();

  const showModal = () => {
    window?.Moengage?.track_event("credit-score_info_click");
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getCreditScore = async (h) => {
    let hash = encodeURIComponent(h);
    let initialCusStatus = sessionStorage.getItem("initialCusStatus");
    try {
      const res = await onecodeAPI.post("/public/customer/creditDetails", {
        hash: hash,
        initialCusStatus: parseInt(initialCusStatus),
      });
      // console.log(res?.data?.response, "creditscoreres");
      if (res?.data?.response == "No Credit Report") {
        setNoCreditReport(true);
      } else {
        let personalLoansCount = res?.data?.response?.personal_loans;
        let creditCardsCount = res?.data?.response?.credit_cards;
        let activeAccountsCount = res?.data?.response?.active_accounts;
        let creditScore = res?.data?.response?.credit_score;
        let bureau = res?.data?.response?.bureau;
        setCreditScoreData({
          personalLoans: Math.trunc(personalLoansCount),
          creditCards: Math.trunc(creditCardsCount),
          activeAccounts: Math.trunc(activeAccountsCount),
          bureauName: bureau,
        });
        setValueEnd(Math.trunc(creditScore));
      }
      setDataLoading(false);
    } catch (error) {
      console.log("error fetching credit Report");
    }
  };

  const getCustomerDetails = async (h) => {
    let hash = encodeURIComponent(h);
    try {
      const res = await onecodeAPI.post("public/customer/getAgentDetails", {
        hash: hash,
      });
      const {
        data: {
          result: { customer },
        },
      } = res;
      if (customer != null) {
        setCustomer(customer);
      }
    } catch (error) {
      console.log("error fetching customer details");
    }
  };

  useEffect(() => {
    getCreditScore(hash);
    getCustomerDetails(hash);
    window?.Moengage?.track_event("credit-score_page_view");
  }, []);

  return (
    <>
      {dataLoading ? (
        <Spin size="large" className="Card6" />
      ) : (
        <div
          style={{
            backgroundColor: "white",
            marginTop: "-20px",
            marginBottom: "-10px",
          }}
        >
          <h4
            style={{
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            <DynamicTextFormatter
              textString={t("creditScore.hello")}
              values={{
                __FullName__: { value: customerDetails?.fullName },
              }}
            />
          </h4>
          {noCreditReport ? (
            <>
              <div
                style={{
                  width: "40%",
                  margin: "0 auto",
                  textAlign: "center",
                  fontSize: "25px",
                  color: "red",
                  marginBottom: "20px",
                  fontWeight: 700,
                }}
              >
                <div style={{ marginBottom: "-10px" }}>NO CREDIT</div>
                <div>REPORT</div>
              </div>
            </>
          ) : (
            <CreditScoreCircularBar valueEnd={valueEnd} showModal={showModal} />
          )}
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "#757575", fontSize: "13px" }}>
              {t("creditScore.creditReportDate")}:
              <span
                style={{
                  fontWeight: 700,
                  fontSize: "16px",
                  color: "black",
                  marginLeft: "10px",
                }}
              >
                {moment().format("DD-MMM-YYYY")}
              </span>
            </p>
          </div>
          {!noCreditReport && creditScoreData?.bureauName != "" && (
            <>
              <div>
                <p
                  style={{
                    color: "#757575",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  {t("creditScore.poweredby")}
                </p>
              </div>
              <div
                style={{ width: "25%", margin: "0 auto", marginTop: "-10px" }}
              >
                <img
                  alt=""
                  src={
                    creditScoreData?.bureauName == "CRIF"
                      ? crifImage
                      : equifaxLogo
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </>
          )}
        </div>
      )}
      <div
        style={{
          height: "1px",
          borderTop: "0.5px solid #C4C4C4",
          marginTop: "10px",
          backgroundColor: "white",
        }}
      ></div>
      <div
        style={{
          display: "flex",
          paddingTop: "10px",
          paddingLeft: "10px",
          backgroundColor: "white",
        }}
      >
        <p style={{ color: "#6C63FF", fontWeight: 600, fontSize: "15px" }}>
          <DynamicTextFormatter
            textString={t("creditScore.total")}
            values={{
              __Count__: {
                value: creditScoreData?.activeAccounts,
              },
            }}
          />
        </p>
        <div style={{ width: "4%" }}>
          <img
            alt=""
            src={alert}
            style={{ width: "100%", marginLeft: "7px", marginTop: "-2px" }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: "10px",
          paddingRight: "10px",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
            fontSize: "15px",
            fontWeight: 500,
          }}
        >
          <div>{t("creditScore.personalLoans")}</div>
          <div>{creditScoreData?.personalLoans}</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
            fontSize: "15px",
            fontWeight: 500,
          }}
        >
          <div>{t("creditScore.creditCards")}</div>
          <div>{creditScoreData?.creditCards}</div>
        </div>
        {creditScoreData?.activeAccounts -
          (creditScoreData?.creditCards + creditScoreData?.personalLoans) !=
          0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
              fontSize: "15px",
              fontWeight: 500,
            }}
            s
          >
            <div>{t("creditScore.otherAccounts")}</div>
            <div>
              {creditScoreData?.activeAccounts -
                (creditScoreData?.creditCards + creditScoreData?.personalLoans)}
            </div>
          </div>
        )}
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
            fontSize: "15px",
            fontWeight: 500,
          }}
        >
          <div>Delinquent Accounts</div>
          <div>1</div>
        </div> */}
      </div>
      <div
        style={{
          height: "1px",
          borderTop: "0.5px solid #C4C4C4",
          marginTop: "0px",
        }}
      ></div>
      <div
        style={{
          width: "90%",
          //   height: "150px",
          backgroundColor: "white",
          margin: "0 auto",
          marginTop: "20px",
          boxShadow: "0px 1px 12px rgba(60, 59, 59, 0.2)",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px 20px",
          rowGap: "15px",
        }}
      >
        {/* <div
          style={{
            padding: "10px",
            backgroundColor: "white",
            width: "100%",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            border: "0.5px solid #757575",
          }}
        >
          <div style={{ flex: 1 }}>
            <img alt="" src={deatailedIcon} style={{ width: "100%" }} />
          </div>
          <div
            style={{
              flex: 11,
              fontSize: "12px",
              fontWeight: 600,
              paddingLeft: "15px",
            }}
          >
            View Detailed Report
          </div>
          <div
            style={{
              flex: 1,
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <img alt="" src={arrowRight} style={{ width: "50%" }} />
          </div>
        </div> */}
        <div
          style={{
            padding: "10px",
            backgroundColor: "white",
            width: "100%",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            border: "0.5px solid #757575",
          }}
          onClick={() => {
            navigate("/faqsCreditScore", {
              state: { hash: hash },
            });
            window?.Moengage?.track_event("credit-score_faqs");
          }}
        >
          <div style={{ flex: 1 }}>
            <img alt="" src={faqIcon} style={{ width: "100%" }} />
          </div>
          <div
            style={{
              flex: 11,
              fontSize: "12px",
              fontWeight: 600,
              paddingLeft: "15px",
            }}
          >
            {t("creditScore.Faqs")}
          </div>
          <div
            style={{
              flex: 1,
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <img alt="" src={arrowRight} style={{ width: "50%" }} />
          </div>
        </div>
      </div>
      <CreditScoreInfoModal
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
    </>
  );
}
